module.exports = __webpack_public_path__ + "img/Freya.05506e8b.png";